<template>
  <div class="CommentListItem media media-comment">
    <div class="CommentListItem__body">
      <div class="CommentListItem__avatar">
        <div class="CommentListItem__avatar-circle">
          {{userShortName}}
        </div>
      </div>
      <div class="media-comment-text CommentListItem__content">
        <div class="CommentListItem__head">
          <h6 class="h5 mb-0">
            {{comment.userEmail}}
          </h6>
          <div class="CommentListItem__date">
            {{comment.date | moment("MMM Do, h:mm")}}
          </div>
        </div>
        <p class="text-sm lh-160" v-html="commentText"></p>
        <div class="icon-actions">
          <button 
            @click="toggleReplyOn"
            class="btn btn-sm">
            <span class="text-muted">reply</span>
          </button>
        </div>
        <div 
          v-if="isReplayOn"
          class="CommentListItem__CommentForm">
          <CommentForm @submitComment="submitComment($event)" :autofocus="true" />
        </div>
      </div>
    </div>
    <div 
      v-if="comment.children"
      class="CommentListItem__CommentsList">
      <CommentsList
        :comments="comment.children"
        @submitComment="submitComment($event)" />
    </div>
  </div>
</template>
<script>
  import CommentForm from './CommentForm';

  export default {
    name: 'CommentsListItem',
    components: {
      CommentForm,
      CommentsList: () => import('./CommentsList.vue')
    },
    props: {
      comment: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        isReplayOn: false
      }
    },
    computed: {
      userShortName() {
        return this.comment.userEmail[0];
      },
      commentText() {
        return (this.comment.text || '').replace(/[\r\n]/g, '<br>');
      }
    },
    methods: {
      toggleReplyOn() {
        this.isReplayOn = !this.isReplayOn;
      },
      submitComment(comment) {
        if (!comment.parent) {
          comment.parent = this.comment.id;
          this.isReplayOn = false;
        }
        this.$emit('submitComment', comment);
      }
    }
  }
</script>
<style lang="scss">
.CommentListItem {
  flex-direction: column;
  align-items: stretch;
  margin-top: 15px;

  &__CommentsList{
    margin-left: 50px;
  }

  &__CommentForm { 
    margin-top: 10px;
  }
  
  &__body {
    display: flex;
    border-bottom: 1px solid #e5e5e5; 
  }

  &__avatar-circle {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #fae5e5;
    margin: 10px 10px 10px 0px;
    text-align: center;
    padding-top: 13px;
    text-transform: uppercase;
    color: #b2241f;
    font-weight: bold;
    font-size: 16px;
  }

  &__head {
    display: flex;
    align-items: center;
  }
  &__date {
    font-size: 11px;
    color: #b7b2b2;
    margin-left: 10px;
  }
  

  &__content {
    padding: 10px 0;
    position: relative;
    background: none;
    flex-grow: 1;
  }

  .icon-actions {
    left: -8px;
    position: relative;
  }

  .text-sm {
    margin-bottom: 5px; 
    margin-top: 5px; 
  }
}
</style>
